import { render, staticRenderFns } from "./NextDeliveryDate.vue?vue&type=template&id=01f4c02f&"
import script from "./NextDeliveryDate.vue?vue&type=script&lang=js&"
export * from "./NextDeliveryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports